import { format, type Locale } from "date-fns";

/** The order map's dates and times, so its order rows and job tables read alike. */
export const formatMapDay = (date: Date, locale: Locale) => format(date, "dd MMM yyyy", { locale });

export const formatMapTime = (date: Date, locale: Locale) => format(date, "HH:mm", { locale });

/** A window's hours, «09:00 - 13:00», or its start alone when it has no end. */
export const formatMapWindow = (start: Date, end: Date | null, locale: Locale) =>
  end
    ? `${formatMapTime(start, locale)} - ${formatMapTime(end, locale)}`
    : formatMapTime(start, locale);
